import React, { FC } from 'react';
import clsx from 'clsx';
import * as Styled from './OModal.styles';
import { OModalProps } from './OModal.types';
import { MModalFooter } from '../../molecules/MModalFooter';
import { MModalHeader } from '../../molecules/MModalHeader';
import MSlot from '../../molecules/MSlot';

export const OModal: FC<OModalProps> = ({
  type = 'Dialog',
  scrolling = false,
  footer = true,
  mModalHeader,
  mModalFooter,
  pagePath,
  itemPath,
  cqPath,
  className,
  i18nProperties,
}) => {
  return (
    <Styled.Wrapper
      data-testid="mi-web-ui-kit-OModal"
      data-modal-type={type}
      className={clsx('container', `o-modal-${type.toLowerCase()}`, className)}
    >
      <Styled.ModalContainer className="row">
        <Styled.ModalContent className="col-12">
          {mModalHeader && (
            <Styled.HeaderSection>
              <MModalHeader
                {...mModalHeader}
                i18nProperties={{
                  ...mModalHeader.i18nProperties,
                  ...i18nProperties,
                }}
              />
            </Styled.HeaderSection>
          )}

          <Styled.ContentSection $scrolling={scrolling}>
            {cqPath && pagePath && itemPath && <MSlot pagePath={pagePath} itemPath={`${itemPath}/:itemsOrder`} />}
          </Styled.ContentSection>

          {footer && mModalFooter && (
            <Styled.FooterSection>
              <MModalFooter {...mModalFooter} />
            </Styled.FooterSection>
          )}
        </Styled.ModalContent>
      </Styled.ModalContainer>
    </Styled.Wrapper>
  );
};

export default OModal;
